import { render, staticRenderFns } from "./commonIframe.vue?vue&type=template&id=c8a1a76a&scoped=true&"
import script from "./commonIframe.vue?vue&type=script&lang=js&"
export * from "./commonIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a1a76a",
  null
  
)

export default component.exports